import "./contact.css";

import { useState, useEffect } from "react";
import axios from "axios";

import Logo from "../../Components/Logo";

export default function Contact() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [])

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  async function sendMessage(e) {
    e.preventDefault();

    axios.defaults.headers.post["Content-Type"] = "application/json";
    await axios
      .post("https://formsubmit.co/ajax/leandro.asalles182@gmail.com", {
        Nome: name,
        Email: email,
        Whatsapp: phone,
        Mensagem: message,
      })
      .then(() => {
        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
      })
      .catch((error) => console.log(error));
  }

  return (
    <div className="contact">
      <Logo id="logo" />
      <form id="form">
        <h2 className="tittle contact--title">
          Envie sua mensagem <strong>( )</strong>
        </h2>
        <div className="contact--inputs">
          <label>Nome:</label>
          <input type="text" name="Nome" value={name} onChange={(e) => setName(e.target.value)}/>

          <label>Email:</label>
          <input type="email" name="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>

          <label>Whatsapp:</label>
          <input type="tel" name="Whatsapp" value={phone} onChange={(e) => setPhone(e.target.value)}/>

          <label>Mensagem:</label>
          <textarea name="Mensagem" id="" cols="30" rows="10" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>

          <input type="hidden" name="_captcha" value="false" />
        </div>
        <button className="primary-button contact--btn" onClick={sendMessage}>
          Enviar mensagem
        </button>
      </form>
    </div>
  );
}
